// store/modules/dashboardDrawer.js
const state = {
  dashboardDrawer: false,
}

const mutations = {
  toggleDashboardDrawer(state, payload) {
    if (typeof payload === "boolean") {
      state.dashboardDrawer = payload
    } else {
      state.dashboardDrawer = !state.dashboardDrawer
    }
  },
}

const actions = {
  toggleDashboardDrawer({ commit }, value) {
    commit("toggleDashboardDrawer", value)
  },
}

const getters = {
  isDashboardDrawerOpen(state) {
    return state.dashboardDrawer
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
